import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-progress-dialog',
  templateUrl: './progress-dialog.component.html',
  styleUrls: ['./progress-dialog.component.css']
})
export class ProgressDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ProgressDialogComponent>,
    private router: Router
  ) {}

  onOk(): void {
    this.dialogRef.close();
  }

  onGoToHistory(): void {
    this.dialogRef.close();
    void this.router.navigate(['/admin/history']);
  }
}

